import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

// Styles
import styles from './tooltipOnOverflowContainer.module.scss'

class TooltipOnOverflowContainer extends React.Component {
    state = {
        isOverflow: false,
    }

    handleMouseEnter = e => {
        if (
            !this.state.isOverflow &&
            e.target.scrollWidth > e.target.clientWidth
        ) {
            this.setState({ isOverflow: true })
        }
        if (
            !this.state.isOverflow &&
            e.target.scrollHeight > e.target.clientHeight
        ) {
            this.setState({ isOverflow: true })
        }
    }

    render() {
        const { text, className } = this.props
        return (
            <div
                className={cx(styles.container, className)}
                onMouseEnter={this.handleMouseEnter}
            >
                {this.state.isOverflow && (
                    <>
                        <div className={styles.tooltip} aria-hidden="true">
                            <div className={styles.arrow} />
                            <span>{text}</span>
                        </div>
                    </>
                )}
                {text}
            </div>
        )
    }
}

TooltipOnOverflowContainer.propTypes = {
    text: PropTypes.node.isRequired,
    className: PropTypes.string,
}

export default TooltipOnOverflowContainer
